import { Bot, Camera } from 'lucide-react';
import type { MazeCameraMode } from '@/flow/animation/useWegoAnimationScene';

type MazeCameraModeToggleProps = {
  value: MazeCameraMode;
  onChange: (mode: MazeCameraMode) => void;
};

const MODES: Array<{ value: MazeCameraMode; label: string; icon: typeof Camera }> = [
  { value: 'free', label: 'フリーカメラ', icon: Camera },
  { value: 'robot', label: 'ロボット視点', icon: Bot },
];

export function MazeCameraModeToggle({ value, onChange }: MazeCameraModeToggleProps) {
  return (
    <div className="maze-camera-modes" role="group" aria-label="カメラモード">
      {MODES.map((mode) => {
        const Icon = mode.icon;
        const selected = value === mode.value;
        return (
          <button
            key={mode.value}
            type="button"
            className={`maze-camera-mode-button ${selected ? 'is-selected' : ''}`}
            aria-pressed={selected}
            onClick={() => onChange(mode.value)}
          >
            <Icon aria-hidden="true" size={15} />
            {mode.label}
          </button>
        );
      })}
    </div>
  );
}